import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const LightBulbIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 3V5M9 18V20M19 5L17.586 6.414M5 5L6.414 6.414M18 21V14C18 10.686 15.314 8 12 8C8.686 8 6 10.686 6 14V21M19 21C19 21 18.333 21 18 21L6 21M6 21H5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
  </svg>
);

LightBulbIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(LightBulbIcon);
